export enum FlashTypes {
  torchOn = 0,
  strobeOn = 1,
  vibrate = 3,
  color = 5,
  screenStrobe = 6,
  imageFadeIn = 7,
  imageFadeOut = 8,
  imagePrefetch = 16,
  imageFetchAndShow = 31,
  takeSelfie = 32,
  audioPrefetch = 43,
  audioPlay = 44,
  sparkleRampUp = 58,
  sparkleSteady = 59,
  sparkleRampDown = 60,
  sequenceStart = 1001
}
